/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from "@glimmer/component";
import AdherencePredictionComputedJournalEvent from "core/models/adherence-prediction-computed-journal-event";
import HospitalisationRiskPredictionComputedJournalEvent from "core/models/hospitalisation-risk-prediction-computed-journal-event";
import ToxicityPredictionComputedJournalEvent from "core/models/toxicity-prediction-computed-journal-event";
import styles from "./index.module.css";
export default class PredictionRiskScoreComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
  }
  get scoreCategory() {
    return this.args.predictionComputedJe?.[`${this.args.riskType}ScoreCategory`] || "inconnu";
  }
  get scoreCategoryColor() {
    switch (this.scoreCategory) {
      case "faible":
        return "green";
      case "moyen":
        return "orange";
      case "élevé":
        return "red";
      default:
        return "brown";
    }
  }
}